module.exports = __webpack_public_path__ + "img/29.a27d994a.png";